module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_8.eefd40a3.jpg";